<div class="fw-bold bg-white p-3 rounded-5 mb-5">
    <!-- Primera fila -->
    <div class="row mt-3">
      <div class="col">
        <label for="information" class="labelInformation">{{
          information
        }}</label>
      </div>
      <div class="col btn-back text-end">
        <button class="btn btn-secondary" (click)="goBack()">Back</button>
      </div>
    </div>
  
    <!-- Segunda fila -->
    <div class="row mt-3">
      <div class="col">
        <label for="customerName">Customer name<span class="required">*</span></label>
        <input
          type="text"
          class="form-control input-label"
          (input)="checkFields()"
          [(ngModel)]="customerName"
        />
      </div>
      <div class="col">
        <label for="address" class="">Address</label>
        <input type="text" style="display:none" />  <!-- Чтобы не отображался диалог сохранения адреса -->
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="address" />
      </div>
      <div class="col">
        <label for="customerCity">City</label>
        <input
          type="text"
          class="form-control input-label"
          (input)="checkFields()"
          [(ngModel)]="city"
        />
      </div>
    </div>
  
    <!-- Cuarta fila -->
    <div class="row mt-3">
      <div class="col">
        <label for="state" class="input-label">State</label>
        <div class="dropdown">
          <select
            class="form-select input-label"
            [(ngModel)]="stateSelected"
            (change)="checkFields()"
          >
            <option value="">Select Value</option>
            <option *ngFor="let option of states" [value]="option.aValue">
              {{ option.aDescription }}
            </option>
          </select>
        </div>
      </div>
      <div class="col">
        <label for="zipCode" class="">ZIP code</label>
        <input
          type="number"
          class="form-control input-label"
          (input)="checkFields()"
          [(ngModel)]="zipCode"
        />
      </div>
      <div class="col">
        <label for="contactNumber" class="">Contact number<span class="required">*</span></label>
        <input
          type="text"
          class="form-control input-label"
          (input)="checkFields()"
          [(ngModel)]="contactNumber"
          appFormatPhoneUs
        />
      </div>
    </div>
  
    <!-- Tercera fila -->
  <!-- Tercera fila -->
  <form [formGroup]="form">
    <div class="row mt-3">
      <div class="col-4">
        <label for="email">Email<span class="required">*</span></label>
        <input
          type="email"
          class="form-control input-label"
          formControlName="email"
          [(ngModel)]="email"
          name="email"
          (change)="checkEmailValidity()"
          (input)="checkFields()"
          appFormatEmail
        />
        <div *ngIf="emailModel?.errors?.['emailInvalid']">
          Email is not valid
        </div>
      </div>
    </div>
  </form>
  
    <!-- Cuarta fila -->
    <div class="row mt-3">
      <div class="col text-end">
        <button
          class="btn btn-primary"
          [disabled]="!fieldsCompleted"
          (click)="updateCustomer()"
        >
          Save partner info
        </button>
      </div>
    </div>
  </div>
